export default __webpack_public_path__ + "static/media/heart.20eeea8c.svg";